export enum RecognitionSettingsTabs {
  library = "library",
  history = "history",
}
